let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("humlJ")).then(() => parcelRequire('kfHyZ'));